"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {
    getFarmingRewards: {
      description: 'Get farming rewards',
      params: [{
        name: 'who',
        type: 'AccountId'
      }, {
        name: 'pid',
        type: 'PoolId'
      }, {
        name: 'at',
        type: 'Hash',
        isOptional: true
      }],
      type: 'Vec<(SpacewalkPrimitivesCurrencyId, Balance)>'
    },
    getGaugeRewards: {
      description: 'Get gauge rewards',
      params: [{
        name: 'who',
        type: 'AccountId'
      }, {
        name: 'pid',
        type: 'PoolId'
      }, {
        name: 'at',
        type: 'Hash',
        isOptional: true
      }],
      type: 'Vec<(SpacewalkPrimitivesCurrencyId, Balance)>'
    }
  },
  types: {
    PoolId: 'u32'
  },
  typesAlias: {}
};
exports.default = _default;